module.exports = __webpack_public_path__ + "static/media/reaction_icon.7ad61f06.png";